import { isObject } from './common';

export class NotImplementedError extends Error {
  constructor(message?: string) {
    const wrapped: string = message ? ` (${message})` : ``;
    super(`Not Implemented ${wrapped}`);
  }
}

/**
 * A callable rejects with `failed-precondition` when the user has to act
 * before retrying, such as reconnecting Stripe, so its message is written to
 * be shown to them.
 */
export function isFailedPreconditionError(
  error: unknown
): error is { code: string; message: string } {
  return (
    isObject(error) &&
    error.code === 'functions/failed-precondition' &&
    typeof error.message === 'string'
  );
}
